import { chatBaseApi } from "@/redux/api/chatApi";
import { TQueryParam } from "../user/userApi";
type ApiResponse<T> = {
  success: boolean;
  message?: string;
  data: T;
};

export type ChatRoomDTO = {
  _id: string;
  room_id: string;
  client_id: string | { _id: string };
  creator_id: string | { _id: string };
};

export type ChatMessageDTO = {
  _id: string;
  chat_room_id: string | { _id: string };
  sender_id: any;
  receiver_id: any;
  content: string;
  message_type: "text" | "form" | string;
  status?: string;
  timestamp: string | Date;
};

export type GetMessagesDTO = {
  messages: ChatMessageDTO[];
  pagination: {
    page: number;
    limit: number;
    totalMessages: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
};

export const chatApi = chatBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    createChatRoom: builder.mutation<
      ApiResponse<ChatRoomDTO>,
      { creator_id: string }
    >({
      query: ({ creator_id }) => ({
        url: "/chat/rooms",
        method: "POST",
        body: { creator_id },
      }),
    }),
    sendMessage: builder.mutation<
      ApiResponse<ChatMessageDTO>,
      { receiver_id: string; content: string; message_type?: "text" | "form" }
    >({
      query: (body) => ({
        url: "/chat/messages",
        method: "POST",
        body,
      }),
      invalidatesTags: ["rooms"],
    }),
    getMessages: builder.query<
      ApiResponse<GetMessagesDTO>,
      { roomId: string; limit?: number; page?: number }
    >({
      query: ({ roomId, limit = 50, page = 1 }) => ({
        url: `/chat/rooms/${roomId}/messages?limit=${limit}&page=${page}`,
        method: "GET",
      }),
    }),
    getUserOnlineOfflineStatus: builder.query({
      query: (userId) => ({
        url: `/chat/user/${userId}/online-status`,
        method: "GET",
      }),
    }),
    getRoomDetails: builder.query({
      query: (roomId) => ({
        url: `/chat/room-data/id/${roomId}`,
        method: "GET",
      }),
    }),
    getRooms: builder.query({
      //aka conversations
      query: (args) => {
        const params = new URLSearchParams();
        if (args) {
          args.forEach((element: TQueryParam) => {
            params.append(element.name, element.value as string);
          });
        }
        return {
          url: `/chat/conversations`,
          method: "GET",
          params,
        };
      },
      providesTags: ["rooms"],
    }),
  }),
});

export const {
  useCreateChatRoomMutation,
  useSendMessageMutation,
  useGetMessagesQuery,
  useGetRoomsQuery,
  useGetUserOnlineOfflineStatusQuery,
  useGetRoomDetailsQuery,
} = chatApi;
